/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModelUtils } from '../../cmd/util/ModelUtils';
import { NodeCompat } from '../../compat/NodeCompat';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasVisitor } from '../visitors/IOasVisitor';

/**
 * Constructor.
 * @param {string} path
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class OasPathItem extends ExtensibleNode implements IOasParameterParent, IReferenceNode {
    /*private*/ _path : string;

    public $ref : string;

    public get : OasOperation;

    public put : OasOperation;

    public post : OasOperation;

    public delete : OasOperation;

    public options : OasOperation;

    public head : OasOperation;

    public patch : OasOperation;

    public parameters : Array<OasParameter>;

    public constructor(path : string) {
        super();
        if(this._path===undefined) this._path = null;
        if(this.$ref===undefined) this.$ref = null;
        if(this.get===undefined) this.get = null;
        if(this.put===undefined) this.put = null;
        if(this.post===undefined) this.post = null;
        if(this.delete===undefined) this.delete = null;
        if(this.options===undefined) this.options = null;
        if(this.head===undefined) this.head = null;
        if(this.patch===undefined) this.patch = null;
        if(this.parameters===undefined) this.parameters = null;
        this._path = path;
    }

    /**
     * Rename the path item (change its path value).
     * @param {string} newPath
     */
    public rename(newPath : string) {
        this._path = newPath;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.IOasParameterParent#getParameters()
     * @return {OasParameter[]}
     */
    public getParameters() : Array<OasParameter> {
        return this.parameters;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.IOasParameterParent#getParametersIn(java.lang.String)
     * @param {string} in
     * @return {OasParameter[]}
     */
    public getParametersIn(__in : string) : Array<OasParameter> {
        let params : Array<OasParameter> = <any>([]);
        if(ModelUtils.isDefined(this.parameters)) {
            this.parameters.forEach(((params) => {
                return (param) => {
                    if(NodeCompat.equals(param.in, __in)) {
                        /* add */(params.push(param)>0);
                    }
                }
            })(params));
        }
        return params;
    }

    /**
     * Gets the path string.
     * @return {string}
     */
    public getPath() : string {
        return this._path;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let oasVisitor : IOasVisitor = <IOasVisitor><any>visitor;
        oasVisitor.visitPathItem(this);
    }

    /**
     * Creates an OAS operation object.
     * @param {string} method
     * @return {OasOperation}
     */
    public abstract createOperation(method : string) : OasOperation;

    /**
     * Creates a child parameter.
     * @return {OasParameter}
     */
    public abstract createParameter() : OasParameter;

    /**
     * Adds a parameter.
     * @param {OasParameter} param
     * @return {OasParameter}
     */
    public addParameter(param : OasParameter) : OasParameter {
        if(this.parameters == null) {
            this.parameters = <any>([]);
        }
        /* add */(this.parameters.push(param)>0);
        return param;
    }

    /**
     * Returns a single, unique parameter identified by "in" and "name" (which are the two
     * properties that uniquely identify a parameter).  Returns null if no parameter is found.
     * @param {string} in
     * @param {string} name
     * @return {OasParameter}
     */
    public getParameter(__in : string, name : string) : OasParameter {
        if(this.parameters == null) {
            return null;
        }
        for(let index167=0; index167 < this.parameters.length; index167++) {
            let param = this.parameters[index167];
            {
                if(NodeCompat.equals(__in, param.in) && NodeCompat.equals(name, param.name)) {
                    return param;
                }
            }
        }
        return null;
    }

    /**
     * Sets the given operation on this path item.
     * @param {OasOperation} operation
     */
    public setOperation(operation : OasOperation) {
        if(NodeCompat.equals("get", operation.getMethod())) {
            this.get = operation;
        } else if(NodeCompat.equals("put", operation.getMethod())) {
            this.put = operation;
        } else if(NodeCompat.equals("post", operation.getMethod())) {
            this.post = operation;
        } else if(NodeCompat.equals("delete", operation.getMethod())) {
            this.delete = operation;
        } else if(NodeCompat.equals("head", operation.getMethod())) {
            this.head = operation;
        } else if(NodeCompat.equals("patch", operation.getMethod())) {
            this.patch = operation;
        } else if(NodeCompat.equals("options", operation.getMethod())) {
            this.options = operation;
        }
    }
}
OasPathItem["__class"] = "io.apicurio.datamodels.openapi.models.OasPathItem";
OasPathItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.models.IOasParameterParent"];





import { OasParameter } from './OasParameter';


import { OasOperation } from './OasOperation';


import { IOasParameterParent } from './IOasParameterParent';

